import { useEffect } from "react";

const TawkInfinitive = () => {
  useEffect(() => {
    const loadTawk = () => {
      if (!window.Tawk_API) {
        window.Tawk_API = {};
        window.Tawk_LoadStart = new Date();

        const script = document.createElement("script");
        script.async = true;
        script.src = "https://embed.tawk.to/58da49d6f97dd14875f5a7c5/default";
        script.charset = "UTF-8";
        script.setAttribute("crossorigin", "*");

        document.body.appendChild(script);
      }

      // remove listeners after loading
      window.removeEventListener("scroll", loadTawk);
      window.removeEventListener("click", loadTawk);
      window.removeEventListener("mousemove", loadTawk);
    };

    // Load only after first interaction
    window.addEventListener("scroll", loadTawk, { once: true });
    window.addEventListener("click", loadTawk, { once: true });
    window.addEventListener("mousemove", loadTawk, { once: true });

    // Global click handler for .open-live-chat
    const handleClick = (e) => {
      const target = e.target.closest(".open-live-chat");
      if (target && window.Tawk_API?.toggle) {
        e.preventDefault();
        window.Tawk_API.toggle();
      }
    };

    document.addEventListener("click", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
      window.removeEventListener("scroll", loadTawk);
      window.removeEventListener("click", loadTawk);
      window.removeEventListener("mousemove", loadTawk);
    };
  }, []);

  return null;
};

export default TawkInfinitive;